import { Extension } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import { javascript } from '@codemirror/lang-javascript';
import { python } from '@codemirror/lang-python';
import { java } from '@codemirror/lang-java';
import { cpp } from '@codemirror/lang-cpp';
import { rust } from '@codemirror/lang-rust';
import { go } from '@codemirror/lang-go';
import { oneDark } from '@codemirror/theme-one-dark';

export const getLanguageExtension = (language: string): Extension => {
  switch (language.toLowerCase()) {
    case 'javascript':
    case 'js':
      return javascript();
    case 'typescript':
    case 'ts':
      return javascript({ typescript: true });
    case 'python':
    case 'py':
      return python();
    case 'java':
      return java();
    case 'cpp':
    case 'c++':
    case 'cxx':
      return cpp();
    case 'rust':
    case 'rs':
      return rust();
    case 'go':
      return go();
    default:
      return javascript(); // fallback
  }
};

export const getThemeExtension = (isDark: boolean): Extension | undefined => {
  return isDark ? oneDark : undefined;
};

export const getCompactViewExtension = (): Extension => {
  return EditorView.theme({
    '&': {
      height: '36px !important',
      maxHeight: '36px !important',
      overflow: 'hidden !important'
    },
    '.cm-content': {
      padding: '1px 4px !important',
      lineHeight: '1.1 !important',
      fontSize: '12px !important'
    },
    '.cm-line': {
      lineHeight: '1.1 !important',
      fontSize: '12px !important'
    },
    '.cm-scroller': {
      overflow: 'hidden !important',
      height: '36px !important',
      maxHeight: '36px !important'
    },
    '.cm-editor': {
      height: '36px !important',
      maxHeight: '36px !important'
    }
  });
};

export const getLanguageDisplayName = (lang: string): string => {
  const displayNames: { [key: string]: string } = {
    javascript: 'JavaScript',
    typescript: 'TypeScript',
    python: 'Python',
    java: 'Java',
    cpp: 'C++',
    rust: 'Rust',
    go: 'Go'
  };
  return displayNames[lang] || lang;
};